<template>
  <div>
    <BaseTopLine>
      <div class="d-flex gap-10 align-items-center"></div>
    </BaseTopLine>
    <div class="p-20">
      <BasePagination :page-count="numPages" :page-range="3" :margin-pages="2" :break-view-class="'d-none'"
        :click-handler="clickLoadData" :prev-text="'Назад'" :next-text="'Далее'"
        :container-class="'pagination pagination-sm'" :page-class="'page-item'" :pageLinkClass="'page-link'">
      </BasePagination>

      <BaseReuseTable :props-data="orgpolicyData" :props-columns-setting="fieldsTableOrgpolicy"
        :selectRowActivateFlag="true" v-if="orgpolicyLoadStatus == 'success'" :callbackForModal="callbackForModal">
      </BaseReuseTable>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Modal from '@/components/Modals.vue'
import EventBus from '@/event-bus.js'
import OrgpolicyService from '@/api/OrgpolicyService.js'
import BaseTextarea from '@/components/ui/BaseTextarea.vue'
export default {
  components: {
    Modal,
    BaseTextarea
  },

  props: {},
  data() {
    return {
      updatedValues: {},
      dataForModal: {},
      editData: {},
      activeSelectRow: null
    }
  },
  methods: {
    clickLoadData(numPage) {
      this.getOrgpolicyAll({
        params: {
          limit: 10,
          page: numPage
        }
      })
    },
    openModalForCreate(nameModal) {
      EventBus.$emit('openModal', {
        data: null,
        nameForAction: nameModal,
        mode: 'create'
      })
    },

    deleteActionAndModal() {
      if (this.activeSelectRow) {
        EventBus.$emit('openModal', {
          data: null,
          nameForAction: 'acceptDelete',
          mode: 'create'
        })
      } else {
        this.$toast.error('Вы не выбрали ни одного поля', { duration: 5000 })
      }
    },
    deleteRow(nameModal) {
      this.deleteOrgpolicyData(this.activeSelectRow)
      this.activeSelectRow = null
      EventBus.$emit('closeModal', { nameForAction: nameModal })
    },

    sendDataFromModal() {
      if (this.dataForModal.orgpolicy__id) {
        this.editOrgpolicyMultiple({
          id: this.dataForModal.orgpolicy__id,
          dataEdit: this.updatedValues
        })
        EventBus.$emit('closeModal', { nameForAction: 'orgpolicyModal' })
      } else {
        this.createOrgpolicyData(this.updatedValues)
        // this.$refs[orgpolicyModal].$el.querySelectorAll('input').forEach(elem => {
        //     elem.value = ''
        // })

        EventBus.$emit('closeModal', { nameForAction: 'orgpolicyModal' })
      }
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value
    },

    prepareKeysForModal(payloadData) {
      this.updatedValues = {}
      this.dataForModal = {}
      if (!payloadData) {
        for (const key in this.orgpolicyData[0]) {
          this.dataForModal[key] = null
        }
      } else {
        this.dataForModal = Object.assign({}, payloadData)
      }
    },

    closeModal(data) {
      this.activeSelectRow = {}
      this.dataForModal = {}
      // this.$refs[data.nameForAction].$el.querySelectorAll('input').forEach(element => {
      //     element.value = ''
      // })
    },
    btnHandlerCloseModal(nameModal) {
      EventBus.$emit('closeModal', { nameForAction: 'orgpolicyModal' })
    },

    ...mapActions('orgpolicyModule', [
      'getOrgpolicyAll',
      'createOrgpolicyData',
      'editOrgpolicyMultiple',
      'deleteOrgpolicyData',
      'downloadOrgpolicyFile',
      'setOrgpolicyRoute'
    ])
  },
  mounted() {
    EventBus.$on('openModal', (payload) => {
      this.editData = payload.data

      this.prepareKeysForModal(payload.data)
    })
    EventBus.$on('selectTableRows', (payload) => {
      this.activeSelectRow = payload.data.Orgpolicy__id
    })
    EventBus.$on('deselectTableRows', (payload) => {
      this.activeSelectRow = null
    })
  },

  created() {
    this.getOrgpolicyAll({ params: { page: 1, limit: 10 } })
  },
  computed: {
    ...mapState('orgpolicyModule', [
      'orgpolicyData',
      'orgpolicyLoadStatus',
      'paginationOrgpolicyStateParams'
    ]),
    ...mapState('translationModule', ['dataLang']),
    ...mapGetters('orgpolicyModule', ['numPages']),

    fieldsTableOrgpolicy() {
      return [
        { title: 'ID', field: 'orgpolicy__id', headerFilter: 'input' },
        {
          title: 'Дата создания',
          field: 'orgpolicy__created_at',
          headerFilter: 'input'
        },
        {
          title: 'Дата актуализации',
          field: 'orgpolicy__updated_at',
          headerFilter: 'input'
        },
        {
          title: 'Наименование',
          field: 'orgpolicy__name',
          headerFilter: 'input'
        },
        {
          title: 'Файл',
          field: 'orgpolicy__file',
          headerFilter: 'input',
          formatter: 'link',
          formatterParams: {
            target: '_blank'
          }
        }
      ]
    }
  }
}
</script>
